<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'apps'
    ]),
    sorted_apps() {
      return Object.values(this.apps).sort((a, b) =>
        (a.title.toLowerCase() > b.title.toLowerCase()) ? 1 : -1)
    }
  },
  data() {
    return {
      create_app_dialog_is_open: false,
      loading: false,
      panel: null
    }
  },
  methods: {
    ...mapActions([
      'load_apps'
    ]),
    on_item_delete() {
      this.panel = null
    },
    on_item_select(idx) {
      this.panel = idx
    }
  },
  mounted() {
    this.loading = true
    this.load_apps()
      .then(() => {
        this.loading = false
      })
  },
  name: 'app-panel'
}
</script>

<template>
<div class='d-flex pos-rel flex-grow-1 justify-center overflow-auto'>
  <div class='flex-grow-1' v-if='!loading'>
    <v-expansion-panels v-model='panel' class='pa-0'
      active-class='active-header' accordion flat>
      <candela-app-panel-item v-for='(app, i) in sorted_apps' :key='i'
        @select='on_item_select' @delete='on_item_delete' :app='app'
        :idx='i' :is_open='panel === i'/>
    </v-expansion-panels>
  </div>
  <div v-else class='d-flex flex-grow-1 justify-center align-center'>
    <v-progress-circular color='secondary' indeterminate/>
  </div>
</div>
</template>

<style lang='sass' scoped>
::v-deep .v-expansion-panel-header__icon
  i
    font-size: 1.0em

::v-deep .v-expansion-panel, .v-expansion-panel--active
  margin-bottom: 0 !important
  margin-top: 0 !important

::v-deep .v-expansion-panel-content__wrap
  padding: 0 !important

.item
  transition: background-color 0.4s

.theme--dark
  .item
    border-bottom: 1px solid var(--v-grey-darken8)
    border-left: 1px solid var(--v-grey-darken7)

  ::v-deep .v-expansion-panel-header--active
    background-color: var(--v-grey-darken8) !important

  ::v-deep .v-expansion-panel, .v-expansion-panel--active
    &:hover
      background-color: var(--v-grey-darken9) !important

.theme--light
  .item
    border-bottom: 1px solid var(--v-grey-lighten5)
    border-left: 1px solid var(--v-grey-lighten3)
    &:hover
      background-color: white

  ::v-deep .v-expansion-panel-header--active
    background-color: var(--v-white-base) !important

  ::v-deep .v-expansion-panel, .v-expansion-panel--active
    &:hover
      background-color: var(--v-white-base) !important
</style>
